<template>
<div class="library-wrap main-1 clearfix">
  <aside class="left" v-if="menu">
    <div>图书分类</div>
    <p
      v-for="item of menu"
      :key="item.id"
      :class="{ active: item.id === mark }"
      @click="mark = item.id, $router.push({ query: { mark: item.id } })"
    >{{ item.className }}</p>
  </aside>
  <main class="left">
    <nuxt-link tag="section" :to="`library/${book.id}`" class="clearfix" v-for="book of list" :key="book.id">
      <div class="cover left">
        <img v-lazy="book.image" alt="">
      </div>
      <div class="info left">
        <div class="line-0 clearfix">
          <p class="left">{{ book.bookName }}</p>
          <p class="right"><span class="yf-text_blue-1">{{ book.viewcount }}</span> 人看过</p>
        </div>
        <div class="line-1"><span class="yf-text_blue-1">{{ book.author }}</span> 著</div>
        <div class="line-2">{{ new Date(book.publishingAt.slice(0, 10)).toLocaleDateString('zh-cn', { year: 'numeric', month: 'long', day: 'numeric' }) }}/<span class="yf-text_blue-1">{{ book.press }}</span> 出版</div>
        <div class="line-3" v-html="book.introduce"></div>
      </div>
    </nuxt-link>
    <!--分页-->
    <y-pager :total="total" />
  </main>
</div>
</template>

<script>
export default {
  scrollToTop: true,
  watchQuery: ['page', 'num', 'mark'],
  async asyncData ({ query, $axios }) {
    let menu = [
        { id: -1, className: '最新图书' },
        { id: -2, className: '最热图书' },
      ],
      mark = Number(query.mark) || menu[0].id,
      page = Number(query.page) || 1,
      num = +query.num || process.env.DEFAULT_PAGE_SIZE,
      bookList = []
    
    let _menu = await $axios._get('/Books/Classification')
    menu = menu.concat(_menu)

    let apiParams = {
      page,
      num
    }
    if (mark > 0) {
      apiParams.bookclassId = mark
    } else {
      apiParams.order = Math.abs(mark)
    }
    
    bookList = await $axios._get('/Books/List', apiParams)
    return {
      menu,
      mark,
      list: bookList.list,
      total: bookList.totalCount
    }
  },
  head () {
    return {
      title: `图书馆_一富财经_股票知识书籍_股票书籍推荐_股票书籍在线阅读`,
      meta: [
        { hid: 'keywords', name: 'keywords', content: '股票书籍_股票学习_图书馆_股票入门基础知识_股票书籍在线阅读' }
      ]
    }
  }
}
</script>

<style lang="less">
.library-wrap {
  padding: 30px 0;
  aside {
    border: 1px solid #eaeaea; width: 210px;
    div, p {
      line-height: 44px; padding-left: 50px;
    }
    div { font-size: 14px; border-bottom: 1px solid #eaeaea; }
    p {
      background-color: #fafafa; color: #666666; cursor: pointer;
      &:not(:last-child) {
        border-bottom: 1px solid #eaeaea;
      }
      &.active {
        background-color: #f3ebe7; color: #c49b88;
      }
    }
  }
  main {
    padding: 28px; border: 1px solid #eaeaea; width: 991px; margin-left: -1px;
    section {
      padding: 20px 0; cursor: pointer;
      .cover {
        width: 115px; height: 150px;
        img, a {
          width: inherit; height: inherit;
        }
      }
      .info {
        margin-left: 40px; width: 778px; font-size: 14px;
        .line-0 {
          .left { font-size: 18px; }
          .right {
            color: #999999;
            span {
              font-style: italic; vertical-align: -5%;
            }
            .yf-text_blue-1 {
              font-size: 24px;
            }
          }
        }
        .line-1 {
          margin-top: 10px; color: #666666;
        }
        .line-2 {
          margin-top: 5px; color: #666666;
        }
        .line-3 {
          color: #999999; margin-top: 10px; line-height: 1.8; height: 50px; overflow: hidden;
        }
      }
    }
  }
}
</style>
